import React, { useContext, useState,useEffect } from "react";
import axios from "axios";
import { dashboardURL } from "../../Config/Url";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import Card from "react-bootstrap/Card";
import SpinnerLoading from "../Common/SpinnerLoading";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { useHistory } from "react-router-dom";
const PriceListQuickLink = () => {
  const {
      updateLocTab,
    } = useContext(GlobalContext);
  const history = useHistory();
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [storeId, setStoreId] = useState(0);

  let config = {
    headers: {
      "X-IsMockup": false,
    },
  };
  //TODO get tenant first store with locTab cijenik

  useEffect(() => {
    axios
      .get(`${dashboardURL}/tenant-store`, config)
      .then((result) => {
        setStoreId(result.data.storeId);
        setIsLoading(false);
      })
      .catch((err) => console.log(err.response));
    
  }, []);

 const handleClick = () => {
    updateLocTab("priceList");
    history.push("/stores/"+storeId)//+localStorage.getItem("tenantId"));
  };

  return (
    <>
      {isLoading && (
        <div className="dashboard-card-spinner">
          <SpinnerLoading />
        </div>
      )}

      {!isLoading && (
       <>
        <a onClick={()=>handleClick()} href=""> <Card.Body className="dashboard-card-body-quick-link">
            <div className="dashboard-card-body-quick-link-image">
              <span
                className="icon icon-shopping-list"
                style={{ fontSize: 50 }}
              ></span>
            </div>
            <div className="dashboard-card-body-quick-link-simpleData">
              Cjenik
            </div>
          </Card.Body></a>
        
        </>
      )}
    </>
  );
};

export default PriceListQuickLink;
